import { PkSpinner } from '@uefadigital/panenka-react';
import { memo } from 'react';

import * as styles from './styles.module.scss';

export const Loader = ({ size = 100 }) => (
  <div className={styles.overlay}>
    <PkSpinner size={size} />
  </div>
);

export default memo(Loader);
